import { getCurrentStore } from "../../../redux/store";
import { translate } from "../../../i18n/translate";
import config from "../../../../config";
import { deviceIdentifier } from "./domuso-responsive";

export const paymentMethodsPaymentFlow = (props: any) => {
  const paymentMethods = {
    ccDebitCard: {
      visible: true,
      disabled: [],
    },
    domusoACH: {
      visible: true,
      disabled: [],
    },
    bankAccount: {
      visible: true,
      disabled: [],
    },
    moneygram: {
      visible: true,
      disabled: [],
    },
    checkScanCertified: {
      visible: true,
      disabled: [],
    },
    checkScanPersonal: {
      visible: true,
      disabled: [],
    },
    shouldDisableNonCertifiedMethods: false,
  };

  const deviceType = deviceIdentifier();
  const store = getCurrentStore();
  const currentReduxStoreState = store.getState();
  const currentReservationId = currentReduxStoreState?.payment?.reservationId;
  const currentReservation = currentReduxStoreState?.reservation?.reservations?.find(
    (reservation) => reservation?.id == currentReservationId
  );

  const reservationStatus = currentReservation?.status;
  const residentStatus = currentReservation?.account_system_resident_status;
  const allowedPayments = currentReservation?.accounting_details?.allowedPayments;
  const shouldDisableCC = props?.shouldDisableCC;
  const balanceDue = currentReservation?.balance_due;
  const propertyNonCertifiedThreshold =
    currentReservation?.property_profile?.non_certified_threshold;
  const propertyNonCertifiedLimit = currentReservation?.property_fee_profile?.non_certified_limit;
  const propertyCertifiedStartDate = currentReservation?.property_profile?.certified_start_day;
  const propertyCertifiedEndDate = currentReservation?.property_profile?.certified_end_day;
  const requireCertifiedMoveInPayments =
    currentReservation?.property_profile?.require_certified_move_in_payments;
  const grailsDomusoPaymentMaxAmountSSMParameter = Number(config.paymentMaxAmount) * 100;

  const userEnteredAmount = props?.finalPaymentAmounts?.amount?.toNumber();
  const paymentDate = props?.finalPaymentDate.getDate();
  const paymentDateAsEpoch = new Date(props?.finalPaymentDate)?.valueOf();

  /*
    Rule based on: 
    4. no-balance-self-invited-credit-cards
    status (reservation status) is PENDING in Payment Method Matrices (Google Doc)
    */
  if (reservationStatus == "PENDING") {
    paymentMethods.moneygram.disabled.push(translate("paymentMethods.disableReasons.noBalance"));
  }

  /*
    Rule based on: 
    14. zero-balance-due-moneygram-bill-pay 
    15. negative-balance-due-moneygram-bill-pay 
    */
  if (isNaN(props?.accountingDetails?.balanceDue) || props?.accountingDetails?.balanceDue <= 0) {
    paymentMethods.moneygram.disabled.push(
      translate("paymentMethods.disableReasons.moneygramZeroOrNegativeBalance")
    );
  }

  /*
    Rule based on: 
    25. cash-only-resident-pms
    */
  if (allowedPayments == "CASH_EQUIVALENT") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPayments")
    );
    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPayments")
    );
  }

  /*
    Rule based on: 
    26. cash-only-resident-in-property-certified-payment-range
    */
  if (
    allowedPayments == "CASH_EQUIVALENT" &&
    propertyCertifiedStartDate &&
    propertyCertifiedEndDate &&
    propertyCertifiedStartDate <= paymentDate <= propertyCertifiedEndDate
  ) {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPaymentsNotInCertifiedPaymentRange")
    );
    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPaymentsNotInCertifiedPaymentRange")
    );
  }

  /*
    Rule based on: 
    27. cash-only-future-resident-applicant
    */
  if (allowedPayments == "CASH_EQUIVALENT" && residentStatus == "Applicant") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPayments")
    );
    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.cashOnlyResidentPayments")
    );
  }

  /*
    Rule based on: 
    33. allow-card-payments-set-to-false
    */
  if (!currentReservation?.property_profile?.allow_card_payments) {
    paymentMethods.ccDebitCard.visible = false;
  }

  /*
    Rule based on: 
    34. allow-domuso-cash-set-to-false
    */
  if (!currentReservation?.property_profile?.allow_domuso_cash) {
    paymentMethods.domusoACH.visible = false;
  }

  /*
    Rule based on: 
    35. allow-ach-payments-set-to-false
    */
  if (!currentReservation?.property_profile?.allow_ach_payments) {
    paymentMethods.bankAccount.visible = false;
  }

  /*
    Rule based on: 
    allow_resident_mobile_personal set to False
    */
  if (!currentReservation?.property_profile?.allow_resident_mobile_personal) {
    paymentMethods.checkScanPersonal.visible = false;
  }

  /*
    Rule based on: 
    allow_resident_mobile_certified set to False
    */
  if (!currentReservation?.property_profile?.allow_resident_mobile_certified) {
    paymentMethods.checkScanCertified.visible = false;
  }

  /*
    Rule based on: 
39. allow-moneygram-set-to-false
    */
  if (!currentReservation?.property_profile?.allow_moneygram) {
    paymentMethods.moneygram.visible = false;
  }

  /*
    Rule based on: 
40. residentStatus-is-pending
    */
  if (residentStatus == "Pending") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
41. residentStatus-is-applicant
    */
  if (residentStatus == "Applicant") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
42. residentStatus-is-future-and-require-certified-move-in-payments-is-true
    */
  if (residentStatus == "Future" && requireCertifiedMoveInPayments) {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
46. residentStatus-is-denied
    */
  if (residentStatus == "Denied") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
47. residentStatus-is-canceled
    */
  if (residentStatus == "Canceled") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
48. residentStatus-is-non-resident
    */
  if (residentStatus == "Non_Resident") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }

  /*
    Rule based on: 
50. allowedPayments-set-to-DO-NOT-ACCEPT-PAYMENT
    */
  if (allowedPayments == "DO_NOT_ACCEPT_PAYMENT") {
    paymentMethods.ccDebitCard.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );

    paymentMethods.domusoACH.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );

    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );

    paymentMethods.moneygram.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );

    paymentMethods.checkScanCertified.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.doNotAcceptPayment")
    );
  }

  /*
    Rule based on: 
51. user-entered-amount-greater-than-grails/domuso.payment.max.amount (SSM Parameter)
    */
  if (userEnteredAmount > grailsDomusoPaymentMaxAmountSSMParameter) {
    paymentMethods.domusoACH.disabled.push(
      translate(
        "paymentMethods.disableReasons.userEnteredAmountGreaterThanGrailsDomusoPaymentMaxAmountSSMParameter"
      )
    );
  }

  /*
Rule based on:
51b. user entered amount > non_certified_limit in Payment Method Matrices (Google Doc)
  */
  if (userEnteredAmount > propertyNonCertifiedLimit) {
    paymentMethods.ccDebitCard.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );

    paymentMethods.domusoACH.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );

    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );

    paymentMethods.moneygram.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );

    paymentMethods.checkScanCertified.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );

    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.userEnteredAmountGreaterThanNonCertifiedLimit")
    );
  }

  /*
    Rule based on: 
52. certified-date-certified-start-day-less-than-or-equal-to-selected-payment-date-less-than-or-equal-to-certified-end-day 
    */
  if (propertyCertifiedStartDate && propertyCertifiedEndDate) {
    if (
      propertyCertifiedStartDate <= paymentDate &&
      paymentDate <= propertyCertifiedEndDate &&
      balanceDue > propertyNonCertifiedThreshold
    ) {
      paymentMethods.bankAccount.disabled.push(
        translate(
          "paymentMethods.disableReasons.certifiedDateCertifiedStartDayLessThanOrEqualToSelectedPaymentDateLessThanOrEqualToCertifiedEndDay"
        )
      );

      paymentMethods.checkScanPersonal.disabled.push(
        translate(
          "paymentMethods.disableReasons.certifiedDateCertifiedStartDayLessThanOrEqualToSelectedPaymentDateLessThanOrEqualToCertifiedEndDay"
        )
      );
    }
  }

  /*
    Rule based on: 
53. future-payment-selected-payment-date-greater-than-current-date
    */
  if (paymentDateAsEpoch > new Date().valueOf()) {
    paymentMethods.domusoACH.disabled.push(
      translate(
        "paymentMethods.disableReasons.futurePaymentSelectedPaymentDateGreaterThanCurrentDate"
      )
    );
    paymentMethods.checkScanPersonal.disabled.push(
      translate(
        "paymentMethods.disableReasons.futurePaymentSelectedPaymentDateGreaterThanCurrentDate"
      )
    );
    paymentMethods.checkScanCertified.disabled.push(
      translate(
        "paymentMethods.disableReasons.futurePaymentSelectedPaymentDateGreaterThanCurrentDate"
      )
    );
  }

  /*
    Rule based on: 
54. hasUserCCPayBlock-set to-true
    */
  if (shouldDisableCC) {
    paymentMethods.ccDebitCard.disabled.push(
      translate("paymentMethods.disableReasons.hasUserCCPayBlockSetToTrue")
    );
    paymentMethods.domusoACH.disabled.push(
      translate("paymentMethods.disableReasons.hasUserCCPayBlockSetToTrue")
    );
  }

  /*
    Rule based on: 
55. device-does-not-have-back-facing-camera
    */
  if (deviceType == "webDesktop") {
    paymentMethods.checkScanCertified.disabled.push(
      translate("paymentMethods.disableReasons.noDeviceSupport")
    );
    paymentMethods.checkScanPersonal.disabled.push(
      translate("paymentMethods.disableReasons.noDeviceSupport")
    );
  }
  /*
    Rule based on: 
59. moneygram-pay-partial-amount-of-balance
    */
  if (userEnteredAmount != balanceDue) {
    paymentMethods.moneygram.disabled.push(
      translate("paymentMethods.disableReasons.moneygramPayPartialAmountOfBalance")
    );
  }

  paymentMethods.bankAccount.disabled = [...new Set(paymentMethods.bankAccount.disabled)];
  paymentMethods.ccDebitCard.disabled = [...new Set(paymentMethods.ccDebitCard.disabled)];
  paymentMethods.checkScanCertified.disabled = [
    ...new Set(paymentMethods.checkScanCertified.disabled),
  ];
  paymentMethods.checkScanPersonal.disabled = [
    ...new Set(paymentMethods.checkScanPersonal.disabled),
  ];
  paymentMethods.domusoACH.disabled = [...new Set(paymentMethods.domusoACH.disabled)];
  paymentMethods.moneygram.disabled = [...new Set(paymentMethods.moneygram.disabled)];

  return paymentMethods;
};

export const paymentMethodsAutopayFlow = (props: any) => {
  const paymentMethods = {
    ccDebitCard: {
      visible: true,
      disabled: [],
    },
    domusoACH: {
      visible: false,
      disabled: [],
    },
    bankAccount: {
      visible: true,
      disabled: [],
    },
    moneygram: {
      visible: false,
      disabled: [],
    },
    checkScanCertified: {
      visible: false,
      disabled: [],
    },
    checkScanPersonal: {
      visible: false,
      disabled: [],
    },
    shouldDisableNonCertifiedMethods: false,
  };

  //add logic that only hides and populates disabled arrays

  const store = getCurrentStore();
  const currentReduxStoreState = store.getState();
  const currentReservationId = currentReduxStoreState?.payment?.reservationId;
  const currentReservation = currentReduxStoreState?.reservation?.reservations?.find(
    (reservation) => reservation?.id == currentReservationId
  );
  const residentStatus = currentReservation?.account_system_resident_status;

  /*
    Rule based on: 
    residentStatus-is-applicant
  */
  if (residentStatus == "Applicant") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.ccDebitCard.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }
  /*
    Rule based on: 
    residentStatus-is-future
  */
  if (residentStatus == "Future") {
    paymentMethods.bankAccount.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );

    paymentMethods.ccDebitCard.disabled.push(
      translate("paymentMethods.disableReasons.generalStatus")
    );
  }
  return paymentMethods;
};

export const paymentMethodsRecoveryFlow = () => {
  const paymentMethods = {
    ccDebitCard: {
      visible: true,
      disabled: [],
    },
    domusoACH: {
      visible: true,
      disabled: [],
    },
    bankAccount: {
      visible: true,
      disabled: [],
    },
    moneygram: {
      visible: true,
      disabled: [],
    },
    checkScanCertified: {
      visible: true,
      disabled: [],
    },
    checkScanPersonal: {
      visible: true,
      disabled: [],
    },
  };

  //add logic that only hides and populates disabled arrays

  return paymentMethods;
};
